import { DownloadSimpleIcon } from "@phosphor-icons/react";

/**
 * Small "Export CSV" button used at the top of every report tab.
 *
 * Props:
 *   onExport: () => void  — called when the button is clicked.
 *   disabled: boolean
 *   testId: string
 */
export default function ExportCsvButton({ onExport, disabled = false, testId }) {
  return (
    <button
      type="button"
      onClick={onExport}
      disabled={disabled}
      data-testid={testId}
      className="inline-flex items-center gap-1.5 rounded-md border border-slate-300 bg-white px-2.5 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-amber-500 hover:text-amber-700 disabled:cursor-not-allowed disabled:opacity-50"
      title="Download this tab as CSV"
    >
      <DownloadSimpleIcon size={14} weight="bold" />
      Export CSV
    </button>
  );
}
